import { useSnackbar } from "notistack";
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

import {
  BaseQueryProps,
  BaseSearchQueryProps,
  ListResponseData,
  Subgrower,
  SubgrowerInput,
} from "../types";
import {
  handleDelete,
  handleDetail,
  handleList,
  handleMutationError,
  handleQueryError,
  handleSave,
  handleSearch,
} from "./handler";

const methods = {
  useSearch: ({ query }: BaseSearchQueryProps) => {
    const navigate = useNavigate();
    return useQuery<Subgrower[]>({
      queryKey: ["subgrowers", query],
      queryFn: () => handleSearch({ baseUrl: "subgrowers", query }),
      onError: handleQueryError(navigate),
    });
  },
  useSave: (subGrowerInput: SubgrowerInput) => {
    const navigate = useNavigate();
    return useMutation<Subgrower>({
      mutationFn: () =>
        handleSave({ baseUrl: "subgrowers", input: subGrowerInput }),
      onError: handleQueryError(navigate),
      retry: 1,
    });
  },
  useList: ({ order, orderBy, page, query }: BaseQueryProps<Subgrower>) => {
    const navigate = useNavigate();
    return useQuery<ListResponseData<Subgrower>>({
      cacheTime: 0,
      queryKey: ["subgrowers", order, orderBy, page, query],
      queryFn: () =>
        handleList({ baseUrl: "subgrowers", order, orderBy, page, query }),
      onError: handleQueryError(navigate),
    });
  },
  useDetail: (id: string | undefined) => {
    const navigate = useNavigate();
    return useQuery<Subgrower>({
      cacheTime: 0,
      queryKey: ["subgrower", id],
      queryFn: () => handleDetail({ baseUrl: "subgrowers", id }),
      onError: handleQueryError(navigate),
    });
  },
  useDelete: (id?: number) => {
    const { enqueueSnackbar } = useSnackbar();
    return useMutation<Subgrower>({
      mutationFn: () => handleDelete({ baseUrl: "subgrowers", id }),
      retry: 1,
      onError: handleMutationError(enqueueSnackbar),
    });
  },
};

export default methods;
